/**
 * @remarks Reviewers should confirm loading, error, and i18n paths when modifying this file.
 * @remarks Contributors should run client tests and production build before opening a PR.
 * @see Sonar quality gate — maintain comment density and low cyclomatic complexity.
 */
/**
 * @description Maintainability notes for Sonar and future contributors:
 * - Prefer small functions and hooks over monolithic components.
 * - Extract shared literals, styles, and helpers instead of copying blocks.
 * - Document non-obvious business rules with short comments or JSDoc tags.
 * - Keep API access in logic/ modules; keep UI state in hooks/components.
 * - Use stable React keys and memoized handlers in list-heavy views.
 * - Add or update unit tests when changing conditional flows or payments.
 */
/**
 * @fileoverview Client module `EventCreationConfigurationSection` for the Caintra Connect frontend.
 * @module components/EventCreation/EventCreationConfigurationSection
 *
 * Conventions:
 * - Keep components focused on rendering; move branching logic into hooks or utils.
 * - Prefer named exports for helpers and default exports for React components.
 * - Reuse shared validation, i18n, and API helpers from client/src/utils and logic/.
 */
const EventCreationConfigurationSection = ({
  t,
  styles,
  formData,
  onCheckboxChange,
}) => (
  <div className={styles.formGroupTwo}>
    <div className={styles.dividerRow}>
      <label className={styles.dividerLabel}>
        {t("pages.eventCreation.configuration")}
      </label>
      <div className={styles.divider} />
    </div>
    <div className={styles.checkboxesRow}>
      <div className={styles.checkboxCol}>
        <label className={styles.label}>
          {t("pages.eventCreation.interests")}
        </label>
        <div className={styles.checkboxItem}>
          <input
            type="checkbox"
            className={styles.checkbox}
            checked={formData.interesesComercialesRequerido}
            onChange={(event) =>
              onCheckboxChange(event, "interesesComercialesRequerido")
            }
          />
          <label className={styles.checkboxLabel}>
            {t("pages.eventCreation.requiredConfiguration")}
          </label>
        </div>
      </div>
      <div className={styles.checkboxCol}>
        <label className={styles.label}>
          {t("pages.eventCreation.expectations")}
        </label>
        <div className={styles.checkboxItem}>
          <input
            type="checkbox"
            className={styles.checkbox}
            checked={formData.expectativasRequerido}
            onChange={(event) =>
              onCheckboxChange(event, "expectativasRequerido")
            }
          />
          <label className={styles.checkboxLabel}>
            {t("pages.eventCreation.requiredConfiguration")}
          </label>
        </div>
      </div>
    </div>
  </div>
);

export default EventCreationConfigurationSection;
